import { render } from "./Declaracoes.vue?vue&type=template&id=c72b4ef8"
import script from "./Declaracoes.vue?vue&type=script&lang=js"
export * from "./Declaracoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__